import React, { memo, useState, useEffect } from 'react';
import { Radio, RadioGroup, Tooltip } from 'appkit-react';

import alert from '@components/alert';
import { useSelector } from 'react-redux';
import { projectRole } from '@model';

const showModal = (newMode, config = {}) => {
  alert.confirmWithSave({
    content: newMode === 'auto' ? radioOpts[0].warning : radioOpts[1].warning,
    okText: 'yes',
    cancelText: 'no',
    ...config,
  });
};

const ModalContent = ({ children }) => (
  <div>
    {children}
    <h6>Would you like to proceed?</h6>
  </div>
);

const radioOpts = [
  {
    key: 'auto',
    title: 'Default',
    warning: (
      <ModalContent>
        By reverting to Default View, your changes will reset the Questionnaire
        to the system generated complexity scores.
      </ModalContent>
    ),
    info: 'M&A Gateway logic automatically calculate complexity scores based on answer selections',
  },
  {
    key: 'manual',
    title: 'Edit',
    warning: (
      <ModalContent>
        By switching to Edited View, you are removing the calculation logic of
        the tool. Reverting back to Default View at a later time will reset your
        complexity score and text modifications.
      </ModalContent>
    ),
    info: 'View provides end-user ability to modify complexity scores based on preferred outcome (calculation logic will be turned off)',
  },
];

const RadioTooltip = ({ info = '' }) => (
  <Tooltip
    content={<div className="qs-complexity-manualswitch-tip">{info}</div>}
    placement="bottom-start"
  >
    <span className="appkiticon icon-information-fill" />
  </Tooltip>
);

function ManualOrAutoSwicher({
  onChange,
  disabled,
  currentMode: currentModeInProps,
}) {
  const [currentMode, toggleMode] = useState(radioOpts[0].key);
  const isPwcReadOnly = useSelector(
    ({ common }) =>
      common.projectCompanyInfo?.currentUserPermission ===
      projectRole['View-Only'],
  );
  const isClient =
    JSON.parse(window.localStorage.userInfo || '{}')?.isClient || isPwcReadOnly;

  const handleRadioChange = (e) => {
    if (!e.target || disabled) {
      return;
    }

    const onOk = () => {
      toggleMode(newMode);
      onChange && onChange(newMode);
    };

    const newMode = e.target.value;
    if (newMode !== currentMode) {
      showModal(newMode, {
        onOk,
      });
    }
  };

  useEffect(() => {
    if (isClient && currentModeInProps !== 'manual') {
      onChange('manual');
      return;
    }

    currentModeInProps &&
      currentModeInProps !== currentMode &&
      toggleMode(currentModeInProps);
  }, [currentModeInProps]);

  if (isClient) {
    return null;
  }

  return (
    <div className="manual-auto-switch-wrapper">
      <RadioGroup
        name="radioname"
        value={currentMode}
        onChange={handleRadioChange}
      >
        {radioOpts.map((radio) => (
          <Radio key={radio.key} value={radio.key}>
            {radio.title}
            <RadioTooltip info={radio.info} />
          </Radio>
        ))}
      </RadioGroup>
    </div>
  );
}

export default memo(ManualOrAutoSwicher);
